export enum EPhotoSize {
    NORMAL = 1,
    PREVIEW = 2,
    THUMBNAIL = 3
}

export interface PhotoEventUploadPayload {
    id: string;

    fileName: string;
    base64Data: string;

    studentsIDSJson: string;

    schoolID: number;
    userID: number;
    groupID: number;
    organizationID: number;
    eventDateISO: string;
    isExtemporal: boolean;
    batchID: string;
    totalPhotosInBatch: number;
}

// /** @deprecated */
// const PHOTO_ALUMNO_MAP: Map<string, string> = new Map();

// /** @deprecated */
// export function _URLChildPhoto({ IdUsuario }: IAlumno, sizePhoto: EPhotoSize): string {
//     const id = IdUsuario + "_" + sizePhoto;

//     if (PHOTO_ALUMNO_MAP.has(id))
//         return PHOTO_ALUMNO_MAP.get(id);
//     else {
//         let _url = _SvAlumnoFotoPerfilURL({ IdUsuario, Modificacion: null }, sizePhoto);
//         PHOTO_ALUMNO_MAP.set(id, _url);
//         return _url;
//     }
// }

// /** @deprecated */
// export function _SetURLPhoto(idUsuario: number) {
//     const idThumb = idUsuario + "_" + EPhotoSize.THUMBNAIL;
//     const _url = _SvAlumnoFotoPerfilURL({ IdUsuario: idUsuario, Modificacion: null }, EPhotoSize.THUMBNAIL);

//     PHOTO_ALUMNO_MAP.set(idThumb, _url);

//     const idNorm = idUsuario + "_" + EPhotoSize.NORMAL;
//     if (PHOTO_ALUMNO_MAP.has(idNorm)) {
//         const _urlNorm = _SvAlumnoFotoPerfilURL({ IdUsuario: idUsuario, Modificacion: null }, EPhotoSize.NORMAL);
//         PHOTO_ALUMNO_MAP.set(idNorm, _urlNorm);
//     }

//     const idPrev = idUsuario + "_" + EPhotoSize.PREVIEW;
//     if (PHOTO_ALUMNO_MAP.has(idPrev)) {
//         const _urlPrev = _SvAlumnoFotoPerfilURL({ IdUsuario: idUsuario, Modificacion: null }, EPhotoSize.PREVIEW);
//         PHOTO_ALUMNO_MAP.set(idPrev, _urlPrev);
//     }
// }

// /** @deprecated */
// export function _UpdateURLChildPhoto(idChild: number) {
//     const objChild = _ALUMNOS_MAP.get(idChild);
//     if (objChild) {
//         _SetURLPhoto(objChild.IdUsuario);
//         // const id = objChild.IdUsuario + "_" + EPhotoSize.THUMBNAIL;
//         // objChild.urlPhoto = PHOTO_ALUMNO_MAP.get(id);
//     }
// }